interface DomainSetupCompletionState {
  ready: boolean;
  hasSavedDomain: boolean;
  canProceed: boolean;
  logoUploaded: boolean;
  testEmailComplete: boolean;
}

export function isDomainSetupComplete(progress: DomainSetupCompletionState): boolean {
  return (
    progress.ready &&
    progress.hasSavedDomain &&
    progress.canProceed &&
    progress.logoUploaded &&
    progress.testEmailComplete
  );
}
